import { render, staticRenderFns } from "./DocenteNotas.vue?vue&type=template&id=3fc3a020&"
import script from "./DocenteNotas.vue?vue&type=script&lang=js&"
export * from "./DocenteNotas.vue?vue&type=script&lang=js&"
import style0 from "./DocenteNotas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports